import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { ExternalLink } from "components/common";
const ThreatFoxAdapterDocumentation = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "threatfox.documentation.description",
      components: { siteLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://threatfox.abuse.ch/" }) }
    }
  )));
};
export default ThreatFoxAdapterDocumentation;
